import * as React from 'react';
import { STATUT_COLORS } from './types';

export const StatutBadge = React.forwardRef<HTMLSpanElement, { statut: string }>(function StatutBadge({ statut }, ref) {
  const cls = STATUT_COLORS[statut] ?? 'bg-slate-500/15 text-slate-300 border-slate-500/30';
  return <span ref={ref} className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-md border text-xs ${cls}`}>{statut}</span>;
});

export const Tag = React.forwardRef<HTMLSpanElement, { children: React.ReactNode; color?: 'slate' | 'amber' | 'emerald' | 'sky' | 'violet' }>(function Tag({ children, color = 'slate' }, ref) {
  const map = {
    slate: 'bg-slate-700/40 text-slate-300 border-slate-600/40',
    amber: 'bg-amber-500/15 text-amber-300 border-amber-500/30',
    emerald: 'bg-emerald-500/15 text-emerald-300 border-emerald-500/30',
    sky: 'bg-sky-500/15 text-sky-300 border-sky-500/30',
    violet: 'bg-violet-500/15 text-violet-300 border-violet-500/30',
  };
  return <span ref={ref} className={`inline-flex items-center px-2 py-0.5 rounded-md border text-[11px] ${map[color]}`}>{children}</span>;
});

export const PageTitle = React.forwardRef<HTMLDivElement, { icon?: React.ReactNode; title: string; subtitle?: string; action?: React.ReactNode }>(function PageTitle({ icon, title, subtitle, action }, ref) {
  return (
    <div ref={ref} className="flex items-start justify-between mb-8 gap-4">
      <div>
        <h1 className="text-3xl font-heading text-slate-100 flex items-center gap-3">
          {icon}
          {title}
        </h1>
        {subtitle && <p className="text-sm text-slate-400 mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
});

export const Card = React.forwardRef<HTMLDivElement, { children: React.ReactNode; className?: string }>(function Card({ children, className = '' }, ref) {
  return <div ref={ref} className={`bg-slate-900/60 border border-slate-800 rounded-xl ${className}`}>{children}</div>;
});
